(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beach-event-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=carousel=>{if(carousel.dataset.initialised==='true')return;const slides=Array.from(carousel.querySelectorAll('[data-beach-carousel-slide]'));if(!slides.length)return;carousel.dataset.initialised='true';carousel.dataset.slideCount=String(slides.length);const prev=carousel.querySelector('[data-beach-carousel-prev]'),next=carousel.querySelector('[data-beach-carousel-next]'),dotsWrap=carousel.querySelector('[data-beach-carousel-dots]'),autoplay=carousel.dataset.autoplay==='true'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches,interval=Number(carousel.dataset.interval)||5000;let index=0,timer=null,pointerX=null,stopped=false;const dots=slides.map((slide,i)=>{const dot=document.createElement('button');dot.type='button';dot.className='beach-carousel__dot';dot.setAttribute('aria-label',`Show slide ${i+1}`);dot.addEventListener('click',()=>show(i,true));dotsWrap.appendChild(dot);return dot});const schedule=()=>{if(timer)window.clearTimeout(timer);timer=null;if(!autoplay||stopped||slides.length<2)return;const video=slides[index].querySelector('video');if(video){video.loop=false;video.addEventListener('ended',()=>show(index+1,false),{once:true})}else timer=window.setTimeout(()=>show(index+1,false),interval)};const updateVideos=()=>{slides.forEach((slide,i)=>{const video=slide.querySelector('video');if(!video)return;if(i===index){video.loop=!autoplay||stopped;video.play().catch(()=>{})}else{video.pause();video.muted=true;video.loop=false;try{video.currentTime=0}catch(error){}const sound=slide.querySelector('[data-beach-carousel-sound]');if(sound){sound.textContent='Unmute';sound.setAttribute('aria-pressed','false')}}})};function show(nextIndex,manual){if(manual)stopped=true;if(timer)window.clearTimeout(timer);index=(nextIndex+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active))});dots.forEach((dot,i)=>{const active=i===index;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',active?'true':'false')});updateVideos();schedule()}carousel.querySelectorAll('[data-beach-carousel-sound]').forEach(button=>{const video=button.closest('[data-beach-carousel-slide]')?.querySelector('video');if(!video)return;button.addEventListener('click',()=>{stopped=true;video.muted=!video.muted;button.textContent=video.muted?'Unmute':'Mute';button.setAttribute('aria-pressed',String(!video.muted));if(!video.muted)video.play().catch(()=>{})})});prev?.addEventListener('click',()=>show(index-1,true));next?.addEventListener('click',()=>show(index+1,true));carousel.addEventListener('pointerdown',event=>{pointerX=event.clientX;stopped=true});carousel.addEventListener('pointerup',event=>{if(pointerX===null)return;const distance=event.clientX-pointerX;pointerX=null;if(Math.abs(distance)>=50)show(index+(distance<0?1:-1),true)});carousel.addEventListener('pointercancel',()=>{pointerX=null});const section=carousel.closest('.shopify-section');section?.addEventListener('shopify:block:select',event=>{const selected=event.target.closest('[data-beach-carousel-slide]');if(!selected)return;const selectedIndex=slides.indexOf(selected);if(selectedIndex>=0)show(selectedIndex,true)});show(0,false)};const initAll=()=>document.querySelectorAll('[data-beach-carousel]').forEach(init);document.addEventListener('DOMContentLoaded',initAll);document.addEventListener('shopify:section:load',initAll)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beach-event-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => {
    document.querySelectorAll('[data-beach-event]').forEach((section) => {
      const popupNamePrefix = 'beachEventWineClubLogin:';
      const loginLink = section.querySelector('[data-wc-login-link]');
      const loginErrorElement = section.querySelector('[data-login-error]');

      if (loginLink && section.dataset.loginInitialised !== 'true') {
        section.dataset.loginInitialised = 'true';

        const popupName = `${popupNamePrefix}${section.id || 'default'}`;
        let loginPopup = null;
        let popupWatcher = null;

        const stopWatchingPopup = () => {
          if (!popupWatcher) return;
          window.clearInterval(popupWatcher);
          popupWatcher = null;
        };

        const closePopupAndRefresh = () => {
          stopWatchingPopup();

          if (loginPopup && !loginPopup.closed) {
            loginPopup.close();
          }

          loginPopup = null;
          window.location.reload();
        };

        const checkLoginStatus = () => {
          if (!loginPopup) return;

          if (loginPopup.closed) {
            closePopupAndRefresh();
            return;
          }

          try {
            const popupLocation = new URL(loginPopup.location.href);
            const popupPath = popupLocation.pathname.replace(/\/+$/, '') || '/';

            if (
              popupLocation.origin === window.location.origin &&
              popupPath === '/account'
            ) {
              closePopupAndRefresh();
            }
          } catch (error) {
            // The popup may briefly be cross-origin during authentication. Keep checking.
          }
        };

        loginLink.addEventListener('click', (event) => {
          event.preventDefault();

          const popupWidth = 520;
          const popupHeight = Math.min(760, window.screen.availHeight - 80);
          const popupLeft = Math.max(
            0,
            Math.round((window.screen.availWidth - popupWidth) / 2)
          );
          const popupTop = Math.max(
            0,
            Math.round((window.screen.availHeight - popupHeight) / 2)
          );

          loginPopup = window.open(
            loginLink.href,
            popupName,
            `popup=yes,width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
          );

          if (!loginPopup) {
            if (loginErrorElement) {
              loginErrorElement.textContent =
                'Please allow pop-ups to log in without leaving this page.';
              loginErrorElement.hidden = false;
            }
            return;
          }

          if (loginErrorElement) {
            loginErrorElement.textContent = '';
            loginErrorElement.hidden = true;
          }

          loginPopup.focus();
          stopWatchingPopup();
          popupWatcher = window.setInterval(checkLoginStatus, 250);
        });

        window.addEventListener('beforeunload', stopWatchingPopup);
      }

      if (section.dataset.bookingInitialised === 'true') return;
      section.dataset.bookingInitialised = 'true';

      const quantityInput = section.querySelector('[data-event-quantity]');
      const minusButton = section.querySelector('[data-event-minus]');
      const plusButton = section.querySelector('[data-event-plus]');
      const addButton = section.querySelector('[data-event-add]');
      const errorElement = section.querySelector('[data-event-error]');
      if (!quantityInput || !minusButton || !plusButton || !addButton || !errorElement) return;

      const productId = Number(section.dataset.productId);
      const clampQuantity = () => {
        const parsed = Number.parseInt(quantityInput.value, 10);
        quantityInput.value = String(Math.min(2, Math.max(1, Number.isFinite(parsed) ? parsed : 1)));
        minusButton.disabled = Number(quantityInput.value) <= 1;
        plusButton.disabled = Number(quantityInput.value) >= 2;
      };

      minusButton.addEventListener('click', () => {
        quantityInput.value = String(Number(quantityInput.value) - 1);
        clampQuantity();
      });
      plusButton.addEventListener('click', () => {
        quantityInput.value = String(Number(quantityInput.value) + 1);
        clampQuantity();
      });
      quantityInput.addEventListener('input', clampQuantity);
      quantityInput.addEventListener('change', clampQuantity);

      addButton.addEventListener('click', async () => {
        errorElement.hidden = true;
        errorElement.textContent = '';
        clampQuantity();

        const selectedVariant = section.querySelector('[data-event-variant]:checked');
        if (!selectedVariant) {
          errorElement.textContent = 'Please choose an available session.';
          errorElement.hidden = false;
          return;
        }

        const requestedQuantity = Number(quantityInput.value);
        const selectedVariantId = Number(selectedVariant.value);
        const originalButtonText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Checking cart...';

        try {
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
          const cart = await cartResponse.json();
          if (!cartResponse.ok) throw new Error('We could not check your cart. Please try again.');

          const eventLines = cart.items.filter((item) => Number(item.product_id) === productId);
          const existingQuantity = eventLines.reduce((total, item) => total + Number(item.quantity || 0), 0);
          const hasDifferentSlot = eventLines.some((item) => Number(item.variant_id) !== selectedVariantId);

          if (hasDifferentSlot) {
            throw new Error('Both tickets must be booked for the same session. Please remove your existing event ticket before selecting another time.');
          }
          if (existingQuantity + requestedQuantity > 2) {
            throw new Error('Maximum 2 tickets per member.');
          }

          addButton.textContent = 'Adding tickets...';
          const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: requestedQuantity }] })
          });
          const result = await addResponse.json();
          if (!addResponse.ok) throw new Error(result.description || result.message || 'The tickets could not be added to your cart.');

          window.location.href = window.Shopify.routes.root + 'cart';
        } catch (error) {
          errorElement.textContent = error.message;
          errorElement.hidden = false;
          addButton.disabled = false;
          addButton.textContent = originalButtonText;
        }
      });

      clampQuantity();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-ticket-cart-guard-section"]) return;
  try {
    
  (() => {
    const initialise = () => {
      const guard = document.querySelector('[data-event-cart-guard]');
      if (!guard || guard.dataset.initialised === 'true') return;
      guard.dataset.initialised = 'true';

      const eventProductId = Number(guard.dataset.productId);
      const message = guard.querySelector('[data-event-cart-message]');
      const staticBlocked =
        guard.dataset.alreadyClaimed === 'true' ||
        (guard.dataset.inviteOnly === 'true' && guard.dataset.loggedIn !== 'true') ||
        (guard.dataset.inviteOnly === 'true' && guard.dataset.isEligible !== 'true');

      const checkoutControls = () => Array.from(document.querySelectorAll('[name="checkout"], a[href="/checkout"], a[href$="/checkout"]'));
      const setCheckoutState = (invalid, text) => {
        guard.dataset.invalid = String(invalid);
        guard.classList.toggle('event-ticket-cart-guard--invalid', invalid);
        if (text) message.textContent = text;
        checkoutControls().forEach((control) => {
          if (invalid) {
            control.setAttribute('aria-disabled', 'true');
            control.setAttribute('disabled', 'disabled');
            control.style.pointerEvents = 'none';
            control.style.opacity = '0.5';
          } else {
            control.removeAttribute('aria-disabled');
            control.removeAttribute('disabled');
            control.style.pointerEvents = '';
            control.style.opacity = '';
          }
        });
      };

      const validateCart = async () => {
        if (staticBlocked) { setCheckoutState(true, message.textContent.trim()); return false; }
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        const cart = await response.json();
        if (!response.ok) { setCheckoutState(true, 'We could not verify your event tickets. Please refresh the cart and try again.'); return false; }

        const eventLines = cart.items.filter((item) => Number(item.product_id) === eventProductId);
        const totalQuantity = eventLines.reduce((total, item) => total + Number(item.quantity || 0), 0);
        const variantIds = new Set(eventLines.map((item) => Number(item.variant_id)));
        if (totalQuantity > 2) { setCheckoutState(true, 'Maximum 2 tickets per customer. Please reduce your event ticket quantity to continue.'); return false; }
        if (variantIds.size > 1) { setCheckoutState(true, 'Both tickets must be booked for the same session. Please remove one time slot to continue.'); return false; }
        setCheckoutState(false, 'Event ticket rules: maximum 2 tickets, both for the same session.');
        return true;
      };

      document.querySelectorAll(`[data-cart-line][data-product-id="${eventProductId}"] input[type="number"]`).forEach((input) => { input.max = '2'; });
      document.addEventListener('click', async (event) => {
        const checkout = event.target.closest('[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
        if (!checkout || checkout.dataset.eventGuardApproved === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const valid = await validateCart();
        if (!valid) { guard.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        checkout.dataset.eventGuardApproved = 'true';
        if (checkout.tagName === 'A') window.location.href = checkout.href;
        else if (checkout.form) checkout.form.requestSubmit(checkout);
      }, true);
      validateCart();
    };

    document.addEventListener('DOMContentLoaded', initialise);
    document.addEventListener('shopify:section:load', initialise);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-grid"] && !Shopify.designMode) return;
  try {
    
  const sortEventCards = (root) => {
    root.querySelectorAll('[data-event-list]').forEach((list) => {
      const direction = list.dataset.eventList === 'past' ? -1 : 1;
      const cards = Array.from(list.querySelectorAll('[data-event-timestamp]'));

      cards
        .sort((firstCard, secondCard) => {
          const firstTimestamp = Number(firstCard.dataset.eventTimestamp);
          const secondTimestamp = Number(secondCard.dataset.eventTimestamp);
          return (firstTimestamp - secondTimestamp) * direction;
        })
        .forEach((card) => list.appendChild(card));
    });
  };

  const sortEventFilterButtons = (filterGroup) => {
    const buttonsContainer = filterGroup.querySelector('.events-grid__filters');
    const allButton = filterGroup.querySelector('[data-event-filter-value="all"]');
    const filterButtons = Array.from(
      filterGroup.querySelectorAll('[data-event-filter-value]:not([data-event-filter-value="all"])'),
    );

    if (!buttonsContainer) {
      return;
    }

    filterButtons
      .sort((firstButton, secondButton) => {
        if (filterGroup.dataset.eventFilterGroup === 'month') {
          return firstButton.dataset.eventFilterValue.localeCompare(secondButton.dataset.eventFilterValue);
        }

        return firstButton.textContent.trim().localeCompare(secondButton.textContent.trim());
      })
      .forEach((button) => buttonsContainer.appendChild(button));

    if (allButton) {
      buttonsContainer.prepend(allButton);
    }
  };

  const applyEventFilters = (root) => {
    const upcomingList = root.querySelector('[data-event-list="upcoming"]');

    if (!upcomingList) {
      return;
    }

    const selectedFilters = {};

    root.querySelectorAll('[data-event-filter-group]').forEach((filterGroup) => {
      const selectedButton = filterGroup.querySelector('[data-event-filter-value][aria-pressed="true"]');
      selectedFilters[filterGroup.dataset.eventFilterGroup] = selectedButton?.dataset.eventFilterValue || 'all';
    });

    let visibleCount = 0;

    upcomingList.querySelectorAll('[data-event-month][data-event-location]').forEach((card) => {
      const monthMatches =
        !selectedFilters.month || selectedFilters.month === 'all' || card.dataset.eventMonth === selectedFilters.month;
      const locationMatches =
        !selectedFilters.location ||
        selectedFilters.location === 'all' ||
        card.dataset.eventLocation === selectedFilters.location;
      const isVisible = monthMatches && locationMatches;

      card.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    const emptyMessage = root.querySelector('[data-event-filter-empty]');

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  };

  const initialiseEventFilters = (root) => {
    const filters = root.querySelector('[data-event-filters]');

    if (!filters || filters.dataset.initialised === 'true') {
      return;
    }

    filters.querySelectorAll('[data-event-filter-group]').forEach(sortEventFilterButtons);

    filters.addEventListener('click', (event) => {
      const selectedButton = event.target.closest('[data-event-filter-value]');

      if (!selectedButton || !filters.contains(selectedButton)) {
        return;
      }

      const filterGroup = selectedButton.closest('[data-event-filter-group]');

      if (!filterGroup) {
        return;
      }

      filterGroup.querySelectorAll('[data-event-filter-value]').forEach((button) => {
        button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
      });

      applyEventFilters(root);
    });

    filters.dataset.initialised = 'true';
    applyEventFilters(root);
  };

  const initialiseEventGrids = (scope = document) => {
    scope.querySelectorAll('[data-events-grid]').forEach((root) => {
      sortEventCards(root);
      initialiseEventFilters(root);
    });
  };

  initialiseEventGrids();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseEventGrids(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listening-room-invitation"]) return;
  try {
    
  (() => {
    // Timing controls, in milliseconds. Larger scroll values mean a slower scroll.
    const RSVP_SCROLL_DURATION_MS = 1800;
    const ENVELOPE_AUTO_OPEN_DELAY_MS = 2000;

    const initialize = (root, suppliedCapability) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      let capabilityToken = typeof suppliedCapability === 'string' ? suppliedCapability.trim() : null;
      const proxyBase = root.dataset.proxyBase.replace(/\/$/, '');
      const scene = root.querySelector('.lr-scene');
      const detailsPage = root.querySelector('.lr-details-page');
      const envelopeButton = root.querySelector('.lr-envelope-button');
      const replayButton = root.querySelector('.lr-replay');
      const cardWindow = root.querySelector('.lr-card-window');
      replayButton.disabled = true;
      const guestNameField = root.querySelector('.lr-guest-name');
      const guestNameInput = root.querySelector('[name="guest_name"]');
      const heldLine = root.querySelector('[data-held-line]');
      const secondaryForm = root.querySelector('.lr-secondary-form');
      const complete = root.querySelector('.lr-complete');
      const reopenReceipt = root.querySelector("[data-reopen-receipt]");
      const reopenEyebrow = root.querySelector("[data-reopen-eyebrow]");
      const reopenTitle = root.querySelector("[data-reopen-title]");
      const reopenDate = root.querySelector("[data-reopen-date]");
      const reopenTime = root.querySelector("[data-reopen-time]");
      const reopenVenue = root.querySelector("[data-reopen-venue]");
      const eventDescription = root.querySelector("[data-event-description]");
      const detailsNav = root.querySelector(".lr-details-nav");
      const detailsGrid = root.querySelector(".lr-details-grid");
      const poll = root.querySelector('.lr-poll');
      const invitationFor = root.querySelector('.lr-invite-for');
      const recipientNameElements = root.querySelectorAll('[data-recipient-name]');
      const recordList = root.querySelector('.lr-record-list');
      const otherRecord = root.querySelector('.lr-other-record');
      const suggestion = root.querySelector('[name="record_suggestion"]');
      const suggestionArtist = root.querySelector('[name="record_artist"]');
      const notes = root.querySelector('[name="guest_notes"]');
      const acceptMessage = root.querySelector('[data-accept-message]');
      const detailsMessage = root.querySelector('[data-details-message]');
      const declineTrigger = root.querySelector('.lr-decline-trigger');
      const declineDialog = root.querySelector('.lr-decline-dialog');
      const declineForm = root.querySelector('.lr-decline-form');
      const declineBack = root.querySelector('.lr-decline-back');
      const declineConfirm = root.querySelector('.lr-decline-confirm');
      const declineComplete = root.querySelector('.lr-decline-complete');
      const declineNotes = root.querySelector('[name="decline_notes"]');
      const declineMessage = root.querySelector('[data-decline-message]');
      const statusPanel = root.querySelector('.lr-status-panel');
      const statusMessage = root.querySelector('[data-status-message]');
      const statusRetry = root.querySelector('.lr-status-retry');
      const fullState = root.querySelector('[data-full-state]');
      const fullTitle = fullState.querySelector('h2');
      const fullIntroduction = root.querySelector('[data-full-introduction]');
      const interestConfirmation = root.querySelector('[data-interest-confirmation]');
      const interestButton = root.querySelector('[data-register-interest]');
      const interestMessage = root.querySelector('[data-interest-message]');
      const attendanceNote = root.querySelector('[data-availability-note]');
      const attendanceOptions = root.querySelectorAll('[data-attendance]');
      const declineInline = root.querySelector('[data-decline-inline]');
      const declineNotesInline = root.querySelector('[name="decline_notes_inline"]');
      const attendingOnly = root.querySelectorAll('[data-attending-only]');
      const state = {
        guests: '1',
        attendanceSelected: false,
        record: null,
        status: 'pending',
        revision: null,
        detailsComplete: false,
        totalAttendees: null,
        availability: null,
        interestRegistered: false,
        permittedActions: { accept: true, completeDetails: false, decline: true, registerInterest: false },
        commandKeys: {},
        busy: false
      };
      let timers = [];
      let isRevealed = false;
      let lookupInProgress = false;
      let autoOpenTimer = null;
      let hasStartedOpening = false;
      let stopRsvpScroll = () => {};

      const messages = {
        unavailable: root.dataset.messageUnavailable,
        temporary: root.dataset.messageTemporary,
        rateLimited: root.dataset.messageRateLimited,
        conflict: root.dataset.messageConflict,
        requiredGuest: root.dataset.messageRequiredGuest,
        requiredSuggestion: root.dataset.messageRequiredSuggestion,
        request: root.dataset.messageRequest,
        onePlace: root.dataset.messageOnePlace,
        twoPlaces: root.dataset.messageTwoPlaces
      };

      const imagePromises = Array.from(root.querySelectorAll('.lr-preload img')).map((image) => {
        if (image.complete) return Promise.resolve();
        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      });
      const assetsReady = Promise.all(imagePromises);

      const reveal = () => {
        if (isRevealed) return;
        isRevealed = true;
        root.classList.add('is-ready');
        root.setAttribute('aria-busy', 'false');
        scheduleAutomaticOpening();
      };

      const revealWhenReady = () => {
        assetsReady.then(() => {
          window.requestAnimationFrame(() => window.requestAnimationFrame(reveal));
        });
      };

      const clearMessage = (element) => {
        element.textContent = '';
        element.classList.add('is-hidden');
      };

      const showMessage = (element, message) => {
        element.textContent = message;
        element.classList.remove('is-hidden');
      };

      const showStatus = (message, canRetry) => {
        statusMessage.textContent = message;
        statusRetry.classList.toggle('is-hidden', !canRetry);
        statusPanel.classList.remove('is-hidden');
        scene.classList.add('is-hidden');
        detailsPage.classList.add('is-hidden');
        fullState.classList.add('is-hidden');
        revealWhenReady();
      };

      const hideStatus = () => {
        statusPanel.classList.add('is-hidden');
      };

      const messageForStatus = (status) => {
        if (status === 404) return messages.unavailable;
        if (status === 429) return messages.rateLimited;
        if (status === 409) return messages.conflict;
        if (status >= 500) return messages.temporary;
        return messages.request;
      };

      const createIdempotencyKey = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
      };

      const request = async (action, body) => {
        let response;
        try {
          response = await window.fetch(proxyBase + '/' + action, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
          });
        } catch (error) {
          void error;
          return { ok: false, networkError: true, status: 0, data: null };
        }

        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          void error;
        }
        return { ok: response.ok, networkError: false, status: response.status, data };
      };

      const postMutation = async (action, payload) => {
        if (!state.commandKeys[action]) {
          state.commandKeys[action] = createIdempotencyKey();
        }
        const result = await request(action, Object.assign({
          capabilityToken,
          expectedRevision: state.revision,
          idempotencyKey: state.commandKeys[action]
        }, payload));

        if (!result.networkError && result.status < 500) {
          state.commandKeys[action] = null;
        }
        if (result.ok) {
          state.commandKeys[action] = null;
        }
        return result;
      };

      const formatDate = (value) => {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        const weekday = new Intl.DateTimeFormat('en-AU', {
          weekday: 'long',
          timeZone: 'Australia/Perth'
        }).format(date);
        const calendarDate = new Intl.DateTimeFormat('en-AU', {
          day: 'numeric',
          month: 'long',
          timeZone: 'Australia/Perth'
        }).format(date);
        return weekday + '\n' + calendarDate;
      };

      const formatClock = (value) => {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('en-AU', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
          timeZone: 'Australia/Perth'
        }).format(date).replace(/\s/g, '').toLowerCase();
      };

      const formatTime = (startsAt, endsAt) => {
        const start = formatClock(startsAt);
        const end = endsAt ? formatClock(endsAt) : '';
        return end ? start + ' to\n' + end : start;
      };

      const formatVenue = (venue) => {
        if (!venue) return '';
        return venue.replace(/,\s*/, ',\n');
      };

      const renderReopenReceipt = (event, accepted) => {
        reopenEyebrow.textContent = accepted ? "RSVP received" : "Event details";
        reopenTitle.textContent = accepted ? "We’ll see you there." : "The Listening Room";
        reopenDate.textContent = formatDate(event.startsAt);
        reopenTime.textContent = formatTime(event.startsAt, event.endsAt);
        reopenVenue.textContent = formatVenue(event.venue);

        clearTimers();
        scene.classList.add("is-hidden");
        detailsPage.classList.remove("is-hidden");
        detailsPage.classList.add("is-complete");
        detailsNav.classList.add("is-hidden");
        detailsGrid.classList.add("is-hidden");
        fullState.classList.add('is-hidden');
        reopenReceipt.classList.remove("is-hidden");
        root.style.overflow = "auto";
        window.scrollTo(0, 0);
      };

      const renderRecipient = (candidate) => {
        const normalized = typeof candidate === 'string' ? candidate.trim().toLowerCase() : '';
        const hasName = normalized !== '' && normalized !== 'unnamed' && normalized !== 'unnamed customer';
        recipientNameElements.forEach((element) => {
          element.textContent = hasName ? candidate : '';
          element.classList.toggle('is-hidden', !hasName);
        });
        invitationFor.textContent = hasName ? root.dataset.labelPrivateInvitation : root.dataset.labelNeutralInvitation;
      };

      const setPublicText = (data) => {
        renderRecipient(data.invitee && data.invitee.firstName);
        root.querySelectorAll('[data-event-date]').forEach((element) => { element.textContent = formatDate(data.event.startsAt); });
        root.querySelectorAll('[data-event-time]').forEach((element) => { element.textContent = formatTime(data.event.startsAt, data.event.endsAt); });
        root.querySelectorAll('[data-event-place]').forEach((element) => {
          element.textContent = formatVenue(data.event.venue);
          if (element.hasAttribute('data-invitation-place') || element.hasAttribute('data-rsvp-place')) {
            element.setAttribute('aria-label', (data.event.venue || '') + ' — open in Google Maps (opens in a new tab)');
          }
        });
        const description = typeof data.event.description === "string" ? data.event.description.trim() : "";
        eventDescription.textContent = description;
        eventDescription.classList.toggle("is-hidden", !description);
      };

      const createAlbumButton = (album) => {
        const button = document.createElement('button');
        button.className = 'lr-record-button';
        button.type = 'button';
        button.dataset.record = album.optionId;
        button.dataset.recordKind = 'selected';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');

        let artwork;
        if (album.coverUrl) {
          artwork = document.createElement('img');
          artwork.className = 'lr-album-cover';
          artwork.src = album.coverUrl;
          artwork.alt = album.title;
          artwork.loading = 'lazy';
          artwork.width = 48;
          artwork.height = 48;
        } else {
          artwork = document.createElement('span');
          artwork.className = 'lr-album-placeholder';
          artwork.setAttribute('aria-hidden', 'true');
        }

        const copy = document.createElement('span');
        copy.className = 'lr-record-copy';
        const title = document.createElement('strong');
        title.textContent = album.title;
        const artist = document.createElement('small');
        artist.textContent = album.artist;
        copy.append(title, artist);

        const check = document.createElement('span');
        check.className = 'lr-record-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        button.append(artwork, copy, check);
        return button;
      };

      const createSuggestionButton = () => {
        const button = document.createElement('button');
        button.className = 'lr-record-button';
        button.type = 'button';
        button.dataset.record = 'other';
        button.dataset.recordKind = 'suggestAnother';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');

        const artwork = document.createElement('span');
        artwork.className = 'lr-album-placeholder';
        artwork.setAttribute('aria-hidden', 'true');

        const copy = document.createElement('span');
        copy.className = 'lr-record-copy';
        const title = document.createElement('strong');
        title.textContent = root.dataset.labelSuggestAnother;
        const artist = document.createElement('small');
        artist.textContent = root.dataset.labelAlbumArtist;
        copy.append(title, artist);

        const check = document.createElement('span');
        check.className = 'lr-record-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        button.append(artwork, copy, check);
        return button;
      };

      const renderAlbums = (albums) => {
        if (designMode) return;
        recordList.replaceChildren();
        albums.forEach((album) => recordList.append(createAlbumButton(album)));
        recordList.append(createSuggestionButton());
        state.record = null;
        otherRecord.classList.add('is-hidden');
        suggestion.value = '';
        poll.hidden = false;
      };

      const clearTimers = () => {
        timers.forEach(window.clearTimeout);
        timers = [];
        if (autoOpenTimer !== null) {
          window.clearTimeout(autoOpenTimer);
          autoOpenTimer = null;
        }
        stopRsvpScroll();
      };

      const scrollToRsvp = (top) => {
        stopRsvpScroll();
        const target = Math.max(0, Math.min(top, root.scrollHeight - root.clientHeight));
        const start = root.scrollTop;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || RSVP_SCROLL_DURATION_MS <= 0) {
          root.scrollTo({ top: target, behavior: 'instant' });
          return;
        }

        const startedAt = window.performance.now();
        let frame = null;
        const interruptionEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
        const stop = () => {
          if (frame !== null) window.cancelAnimationFrame(frame);
          interruptionEvents.forEach((event) => root.removeEventListener(event, stop));
          stopRsvpScroll = () => {};
        };
        stopRsvpScroll = stop;
        interruptionEvents.forEach((event) => root.addEventListener(event, stop, { passive: true }));

        const step = (now) => {
          if (!root.isConnected) {
            stop();
            return;
          }
          const progress = Math.min(1, Math.max(0, (now - startedAt) / RSVP_SCROLL_DURATION_MS));
          const eased = progress * progress * (3 - 2 * progress);
          root.scrollTo({ top: start + (target - start) * eased, behavior: 'instant' });
          if (progress < 1) frame = window.requestAnimationFrame(step);
          else stop();
        };
        frame = window.requestAnimationFrame(step);
      };

      const sequence = () => {
        clearTimers();
        hasStartedOpening = true;
        envelopeButton.disabled = true;
        replayButton.disabled = true;
        cardWindow.inert = true;
        detailsPage.classList.add('is-hidden');
        root.style.overflow = 'hidden';
        root.scrollTo({ top: 0, behavior: 'instant' });
        scene.classList.add('is-resetting');
        scene.classList.remove('is-open', 'is-extracting', 'is-envelope-away', 'is-envelope-gone', 'is-focused', 'is-live');
        void scene.offsetWidth;
        scene.classList.remove('is-resetting');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const at = (delay, action) => timers.push(window.setTimeout(action, reduced ? Math.min(delay, 80) : delay));
        at(700, () => scene.classList.add('is-open'));
        at(1900, () => scene.classList.add('is-extracting'));
        at(3500, () => scene.classList.add('is-envelope-away'));
        at(5050, () => scene.classList.add('is-envelope-gone', 'is-focused'));
        at(6650, () => {
          scene.classList.add('is-live');
          cardWindow.inert = false;
          replayButton.disabled = false;
          if (designMode || state.permittedActions.accept || state.permittedActions.completeDetails) showDetails(true);
        });
      };

      const canAutomaticallyOpen = () => (
        root.isConnected &&
        isRevealed &&
        !hasStartedOpening &&
        !envelopeButton.disabled &&
        !scene.classList.contains('is-hidden') &&
        !scene.classList.contains('is-open') &&
        (designMode || (state.status === 'pending' && state.permittedActions.accept && !state.availability?.full))
      );

      const scheduleAutomaticOpening = () => {
        if (autoOpenTimer !== null || !canAutomaticallyOpen()) return;
        autoOpenTimer = window.setTimeout(() => {
          autoOpenTimer = null;
          if (canAutomaticallyOpen()) sequence();
        }, ENVELOPE_AUTO_OPEN_DELAY_MS);
      };

      const setGuestCount = (count) => {
        root.classList.remove('lr-is-declining');
        declineInline.classList.add('is-hidden');
        attendingOnly.forEach((element) => element.classList.remove('is-hidden'));
        state.guests = String(count);
        guestNameField.classList.toggle('is-hidden', state.guests !== '2');
        guestNameInput.required = state.guests === '2';
        const legacyAcceptedDetails = state.status === 'accepted' && !state.detailsComplete;
        heldLine.textContent = legacyAcceptedDetails
          ? 'Your RSVP is already confirmed. Please finish your outstanding details below.'
          : '';
        heldLine.classList.toggle('is-hidden', !legacyAcceptedDetails);
        attendanceOptions.forEach((button) => {
          const selected = button.dataset.attendance === state.guests;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        updateAvailability();
      };

      const updateAvailability = () => {
        const availability = state.availability;
        const guestChoice = root.querySelector('[data-attendance="2"]');
        if (state.status === 'accepted') {
          attendanceNote.textContent = 'Your confirmed attendee count is unchanged.';
          attendanceNote.classList.remove('is-hidden');
          attendanceOptions.forEach((button) => { button.disabled = true; });
          return;
        }
        if (!availability) {
          attendanceNote.textContent = '';
          attendanceNote.classList.add('is-hidden');
          guestChoice.disabled = false;
          return;
        }
        const remaining = availability.remainingSeats;
        attendanceNote.textContent = availability.full
          ? 'This evening has reached capacity.'
          : remaining === 1 ? '1 place remains. A two-person RSVP is not currently available.' : '';
        attendanceNote.classList.toggle('is-hidden', !attendanceNote.textContent);
        guestChoice.disabled = availability.canBringGuest === false;
        if (state.guests === '2' && guestChoice.disabled && !root.classList.contains('lr-is-declining')) {
          attendanceOptions.forEach((button) => {
            const selected = button.dataset.attendance === '2';
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
        }
      };

      const showFullState = (availability, canRegister) => {
        state.availability = availability || state.availability;
        state.permittedActions.registerInterest = Boolean(canRegister);
        clearTimers();
        scene.classList.add('is-hidden');
        detailsPage.classList.remove('is-hidden');
        detailsPage.classList.remove('is-complete');
        detailsNav.classList.add('is-hidden');
        detailsGrid.classList.add('is-hidden');
        reopenReceipt.classList.add('is-hidden');
        fullState.classList.remove('is-hidden');
        fullTitle.textContent = state.interestRegistered ? 'Thank you.' : 'This evening has reached capacity';
        fullIntroduction.classList.toggle('is-hidden', state.interestRegistered);
        interestConfirmation.classList.toggle('is-hidden', !state.interestRegistered);
        interestButton.disabled = state.busy || !state.permittedActions.registerInterest;
        interestButton.classList.toggle('is-hidden', !state.permittedActions.registerInterest || state.interestRegistered);
        if (state.interestRegistered) clearMessage(interestMessage);
        root.style.overflow = 'auto';
        window.scrollTo(0, 0);
        root.querySelector('[id^="FullTitle-"]')?.focus();
      };

      const selectRecord = (button) => {
        state.record = button.dataset.record;
        root.querySelectorAll('.lr-record-button').forEach((recordButton) => {
          const selected = recordButton === button;
          recordButton.classList.toggle('is-selected', selected);
          recordButton.setAttribute('aria-checked', String(selected));
        });
        otherRecord.classList.toggle('is-hidden', button.dataset.recordKind !== 'suggestAnother' && state.record !== 'other');
        suggestion.required = suggestionArtist.required = state.record === 'other';
        if (state.record === 'other') suggestion.focus();
      };

      const setBusy = (busy) => {
        state.busy = busy;
        declineTrigger.disabled = busy || !state.permittedActions.decline;
        declineConfirm.disabled = busy || !state.permittedActions.decline;
        root.querySelector('.lr-finish').disabled = busy || !(state.status === 'pending' ? state.permittedActions.accept : state.permittedActions.completeDetails);
        attendanceOptions.forEach((button) => {
          button.disabled = busy || state.status !== 'pending' || (button.dataset.attendance === '2' && state.availability && state.availability.canBringGuest === false);
        });
        interestButton.disabled = busy || !state.permittedActions.registerInterest;
        root.querySelectorAll('.lr-record-button, .lr-secondary-form input, .lr-secondary-form textarea').forEach((element) => { element.disabled = busy; });
        root.querySelector('.lr-finish').textContent = busy ? 'Confirming…' : 'Confirm RSVP';
        declineTrigger.textContent = busy ? 'Confirming…' : 'Confirm decline';
      };

      const showDetails = (beneathInvitation = false) => {
        clearTimers();
        if (state.status === 'accepted') {
          setGuestCount(state.totalAttendees || state.guests);
        } else if (state.attendanceSelected && state.guests !== 'decline') {
          setGuestCount(state.guests);
        } else if (state.attendanceSelected && state.guests === 'decline') {
          root.classList.add('lr-is-declining');
          declineInline.classList.remove('is-hidden');
          attendingOnly.forEach((element) => element.classList.add('is-hidden'));
          attendanceOptions.forEach((button) => {
            const selected = button.dataset.attendance === 'decline';
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
        } else {
          attendingOnly.forEach((element) => element.classList.add('is-hidden'));
          poll.classList.add('is-hidden');
          guestNameInput.required = false;
          attendanceOptions.forEach((button) => {
            button.classList.remove('is-selected');
            button.setAttribute('aria-pressed', 'false');
          });
        }
        poll.classList.toggle('is-hidden', state.status === 'pending' && (!state.attendanceSelected || state.guests === 'decline'));
        updateAvailability();
        scene.classList.toggle('is-hidden', !beneathInvitation);
        detailsPage.classList.remove('is-hidden');
        detailsPage.classList.remove('is-complete');
        reopenReceipt.classList.add("is-hidden");
        detailsNav.classList.remove("is-hidden");
        detailsGrid.classList.remove("is-hidden");
        fullState.classList.add('is-hidden');
        secondaryForm.classList.remove('is-hidden');
        complete.classList.add('is-hidden');
        root.style.overflow = 'auto';
        if (beneathInvitation) {
          const heading = detailsPage.querySelector('.lr-details-intro h2');
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
          scrollToRsvp(detailsPage.offsetTop);
        } else {
          root.scrollTo({ top: 0, behavior: 'instant' });
        }
      };

      const showComplete = () => {
        clearTimers();
        scene.classList.add('is-hidden');
        detailsPage.classList.remove('is-hidden');
        secondaryForm.classList.add('is-hidden');
        complete.classList.remove('is-hidden');
        detailsPage.classList.add('is-complete');
        root.style.overflow = 'hidden';
      };

      const showDeclined = () => {
        state.status = 'declined';
        state.permittedActions = { accept: false, completeDetails: false, decline: false };
        setBusy(false);
        if (declineDialog.open) declineDialog.close();
        complete.querySelector('h3').textContent = 'Thank you for letting us know.';
        complete.querySelector('p').textContent = 'Your response has been received.';
        showComplete();
        complete.setAttribute('tabindex', '-1');
        complete.focus();
      };

      const applyPublicState = (data) => {
        setPublicText(data);
        if (Array.isArray(data.albums)) renderAlbums(data.albums);
        state.status = data.status;
        state.revision = data.revision;
        state.detailsComplete = data.detailsComplete;
        state.totalAttendees = data.totalAttendees;
        state.permittedActions = data.permittedActions;
        state.availability = data.availability || null;
        state.interestRegistered = Boolean(data.interestRegistered);

        if (data.status === 'accepted' && (data.totalAttendees === 1 || data.totalAttendees === 2)) {
          setGuestCount(data.totalAttendees);
        }
        setBusy(false);

        if (data.status === 'accepted' && data.detailsComplete) {
          renderReopenReceipt(data.event, true);
          return;
        }
        if (data.status === 'accepted' && !data.detailsComplete) {
          showDetails();
          return;
        }
        if (data.status === 'declined') {
          showDeclined();
          return;
        }
        if (data.status === 'pending' && data.availability && data.availability.full) {
          showFullState(data.availability, data.permittedActions && data.permittedActions.registerInterest);
          return;
        }
        scene.classList.remove('is-hidden');
        detailsPage.classList.add('is-hidden');
        fullState.classList.add('is-hidden');
        root.style.overflow = 'hidden';
      };

      const lookup = async () => {
        if (lookupInProgress) return;
        if (!capabilityToken) {
          showStatus(messages.unavailable, false);
          return;
        }

        lookupInProgress = true;
        statusRetry.disabled = true;
        let result = await request('lookup', { capabilityToken });

        if (!result.ok || !result.data) {
          if (!result.networkError && result.status === 404) {
            const eventResult = await request("event", { capabilityToken });
            if (eventResult.ok && eventResult.data && eventResult.data.event) {
              lookupInProgress = false;
              statusRetry.disabled = false;
              hideStatus();
              renderReopenReceipt(eventResult.data.event, false);
              revealWhenReady();
              return;
            }
            // Report a temporary fallback failure as retryable, not as the
            // original lookup's permanent unavailable state.
            result = eventResult;
          }

          lookupInProgress = false;
          statusRetry.disabled = false;
          const retryable =
            result.networkError ||
            result.status >= 500 ||
            result.status === 429;
          showStatus(
            result.networkError
              ? messages.temporary
              : messageForStatus(result.status),
            retryable
          );
          return;
        }

        lookupInProgress = false;
        statusRetry.disabled = false;
        hideStatus();
        applyPublicState(result.data);
        revealWhenReady();
      };

      const refreshAfterConflict = async (messageElement) => {
        const result = await request('lookup', { capabilityToken });
        if (result.ok && result.data) {
          state.revision = result.data.revision;
          state.availability = result.data.availability || null;
          state.permittedActions = result.data.permittedActions || state.permittedActions;
          if (result.data.status === 'pending' && state.availability && state.availability.full && result.data.permittedActions.registerInterest) {
            showFullState(state.availability, true);
          } else {
            updateAvailability();
            showMessage(messageElement, messages.conflict);
          }
          return;
        }
        showMessage(messageElement, result.networkError ? messages.temporary : messageForStatus(result.status));
      };

      const handleMutationFailure = async (result, messageElement) => {
        if (result.status === 409) {
          await refreshAfterConflict(messageElement);
          return;
        }
        showMessage(messageElement, result.networkError ? messages.temporary : messageForStatus(result.status));
      };

      root.querySelectorAll('textarea').forEach((textarea) => {
        const resize = () => {
          textarea.style.height = 'auto';
          textarea.style.height = Math.max(48, textarea.scrollHeight) + 'px';
        };
        textarea.addEventListener('input', resize);
        resize();
      });

      envelopeButton.addEventListener('click', () => {
        if (!envelopeButton.disabled && !scene.classList.contains('is-open')) sequence();
      });
      replayButton.addEventListener('click', sequence);

      recordList.addEventListener('click', (event) => {
        const button = event.target.closest('.lr-record-button');
        if (button && !state.busy) selectRecord(button);
      });
      recordList.addEventListener('keydown', (event) => {
        if (state.busy || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        const buttons = Array.from(recordList.querySelectorAll('.lr-record-button'));
        const index = buttons.indexOf(event.target);
        if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1
          : (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + buttons.length) % buttons.length;
        selectRecord(buttons[next]);
        buttons[next].focus();
      });

      const openDeclineDialog = () => {
        clearMessage(declineMessage);
        if (typeof declineDialog.showModal === 'function') {
          if (!declineDialog.open) declineDialog.showModal();
        } else {
          declineDialog.setAttribute('open', '');
        }
        declineNotes.focus();
      };

      const closeDeclineDialog = () => {
        if (state.status === 'declined') return;
        if (typeof declineDialog.close === 'function') {
          declineDialog.close();
        } else {
          declineDialog.removeAttribute('open');
        }
      };

      declineTrigger.addEventListener('click', (event) => {
        event.stopPropagation();
        declineNotes.value = declineNotesInline.value.trim();
        if (state.permittedActions.decline && !state.busy) declineForm.requestSubmit();
      });
      declineBack.addEventListener('click', closeDeclineDialog);
      declineDialog.addEventListener('click', (event) => {
        if (event.target === declineDialog) closeDeclineDialog();
      });
      declineDialog.addEventListener('cancel', (event) => {
        if (state.status === 'declined') event.preventDefault();
      });

      declineForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearMessage(declineMessage);
        if (designMode) {
          showDeclined();
          return;
        }
        if (!state.permittedActions.decline || state.busy) return;

        setBusy(true);
        const declinePayload = {};
        declinePayload.registerFutureInterest = root.querySelector('[name="future_interest"]').checked;
        const declineNote = declineNotes.value.trim();
        if (declineNote) declinePayload.declineNote = declineNote;
        const result = await postMutation('decline', declinePayload);
        if (result.ok && result.data) {
          applyPublicState(result.data);
          capabilityToken = null;
          return;
        }
        setBusy(false);
        await handleMutationFailure(result, declineDialog.open ? declineMessage : detailsMessage);
      });

      root.querySelector('.lr-back-invite').addEventListener('click', () => {
        scene.classList.remove('is-hidden');
        scene.classList.add('is-open', 'is-extracting', 'is-envelope-away', 'is-envelope-gone', 'is-focused', 'is-live');
        cardWindow.inert = false;
        replayButton.disabled = false;
        root.style.overflow = 'auto';
        root.scrollTo({ top: 0, behavior: 'instant' });
        setBusy(false);
      });

      secondaryForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (state.busy) return;
        if (state.status === 'pending' && !state.attendanceSelected) {
          showMessage(detailsMessage, 'Please choose an attendance option before submitting.');
          root.querySelector('[data-attendance="1"]')?.focus();
          return;
        }
        clearMessage(detailsMessage);
        if (root.querySelector('[data-attendance="decline"]').classList.contains('is-selected')) {
          declineTrigger.click();
          return;
        }
        [guestNameInput, suggestion, suggestionArtist, poll].forEach((element) => {
          element.removeAttribute('aria-invalid');
          element.removeAttribute('aria-describedby');
        });
        const invalid = (element, message) => {
          showMessage(detailsMessage, message);
          element.setAttribute('aria-invalid', 'true');
          element.setAttribute('aria-describedby', detailsMessage.id);
          element.focus();
        };

        const guestName = guestNameInput.value.trim();
        if (state.guests === '2' && !guestName) {
          invalid(guestNameInput, messages.requiredGuest);
          return;
        }
        if (!state.record) {
          invalid(poll, 'Choose one record, or suggest a different album.');
          return;
        }

        let albumResponse = { kind: 'none' };
        if (state.record === 'other') {
          const albumSuggestion = suggestion.value.trim();
          if (!albumSuggestion || albumSuggestion.length > 200) {
            invalid(suggestion, 'Enter an album title of up to 200 characters.');
            return;
          }
          const artist = suggestionArtist.value.trim();
          if (!artist || artist.length > 200) {
            invalid(suggestionArtist, 'Enter the artist’s name (up to 200 characters).');
            return;
          }
          albumResponse = { kind: 'suggestAnother', suggestion: albumSuggestion + ' — ' + artist };
        } else if (state.record) {
          albumResponse = { kind: 'selected', optionId: state.record };
        }

        if (designMode) {
          showComplete();
          return;
        }
        if ((!state.permittedActions.accept && !state.permittedActions.completeDetails) || state.busy) return;

        const legacyDetailsOnly = state.status === 'accepted' && !state.detailsComplete;
        const payload = {};
        if (!legacyDetailsOnly) payload.totalAttendees = Number(state.guests);
        if (state.guests === '2') payload.guestName = guestName;
        const additionalInformation = notes.value.trim();
        if (additionalInformation) payload.additionalInformation = additionalInformation;
        if (albumResponse) payload.albumResponse = albumResponse;

        setBusy(true);
        const result = await postMutation(legacyDetailsOnly ? 'details' : 'submit', payload);
        if (result.ok && result.data) {
          applyPublicState(result.data);
          return;
        }
        setBusy(false);
        if (result.status === 409 && result.data && result.data.code === 'CAPACITY_REACHED') {
          const invitation = result.data.invitation;
          if (invitation) {
            state.revision = invitation.revision;
            state.permittedActions = invitation.permittedActions || state.permittedActions;
          }
          state.availability = result.data.availability || state.availability;
          if (state.availability && !state.availability.full) {
            updateAvailability();
            showMessage(detailsMessage, 'There is not enough capacity for two people. Choose a one-person RSVP to continue.');
          } else {
            showFullState(state.availability, Boolean(invitation && invitation.permittedActions && invitation.permittedActions.registerInterest));
          }
          return;
        }
        await handleMutationFailure(result, detailsMessage);
      });

      interestButton.addEventListener('click', async () => {
        clearMessage(interestMessage);
        if (!state.permittedActions.registerInterest || state.busy || designMode) return;
        setBusy(true);
        if (!state.commandKeys.interest) state.commandKeys.interest = createIdempotencyKey();
        const result = await request('interest', { capabilityToken, idempotencyKey: state.commandKeys.interest });
        if (result.ok || (!result.networkError && result.status < 500)) state.commandKeys.interest = null;
        setBusy(false);
        if (result.ok && result.data) {
          state.interestRegistered = true;
          state.permittedActions.registerInterest = false;
          showFullState(state.availability, false);
          return;
        }
        if (result.status === 409) {
          const lookupResult = await request('lookup', { capabilityToken });
          if (lookupResult.ok && lookupResult.data) {
            state.interestRegistered = Boolean(lookupResult.data.interestRegistered);
            state.permittedActions = lookupResult.data.permittedActions || state.permittedActions;
            if (state.interestRegistered) showFullState(lookupResult.data.availability, false);
            else showMessage(interestMessage, messages.conflict);
            return;
          }
        }
        showMessage(interestMessage, result.networkError ? messages.temporary : messageForStatus(result.status));
      });

      attendanceOptions.forEach((button) => button.addEventListener('click', () => {
        if (state.busy || state.status !== 'pending') return;
        state.attendanceSelected = true;
        clearMessage(detailsMessage);
        if (button.dataset.attendance === 'decline') {
          state.guests = 'decline';
          guestNameInput.required = false;
          suggestion.required = suggestionArtist.required = false;
          attendanceOptions.forEach((option) => {
            const selected = option === button;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-pressed', String(selected));
          });
          root.classList.add('lr-is-declining');
          declineInline.classList.remove('is-hidden');
          attendingOnly.forEach((element) => element.classList.add('is-hidden'));
          return;
        }
        attendingOnly.forEach((element) => element.classList.remove('is-hidden'));
        state.attendanceSelected = true;
        poll.classList.remove('is-hidden');
        setGuestCount(button.dataset.attendance);
      }));

      statusRetry.addEventListener('click', lookup);

      if (designMode) {
        renderRecipient(root.dataset.recipient);
        state.record = null;
        poll.classList.add('is-hidden');
        setBusy(false);
        revealWhenReady();
      } else {
        lookup();
      }
    };

    const initializeAll = (scope, capabilityToken) => {
      scope.querySelectorAll('[data-listening-room]').forEach((root) => initialize(root, capabilityToken));
    };

    window.__singlefileListeningRoomInitialize = initializeAll;
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target, null));
  })();

  } catch(e) { console.error(e); }
})();
})();
